// services/subscriptionCheck.js
//import axios from 'axios';
import { getCurrentUserId } from './database';
import proxyapi from './ProxyApi';

/**
 * Check if the current user can create a generation
 * @returns {Promise<{canGenerate: boolean, message: string, subscriptionStatus: string, trialGenerationsLeft: number}>}
 */
export const canUserGenerate = async () => {
  try {
    const userId = await getCurrentUserId();
    if (!userId) {
      throw new Error('User not authenticated');
    }
    
    // Get the response from the server
    const response = await proxyapi.get(`/api/v1/users/${userId}/can-generate`);
    
    // Simply use what the server tells us - the server is now handling the expiration check
    return {
      canGenerate: response.data.canGenerate === true, // Ensure boolean value
      message: response.data.message,
      subscriptionStatus: response.data.subscriptionStatus,
      trialGenerationsLeft: response.data.trialGenerationsLeft
    };
  } catch (error) {
    console.error('Error checking generation permission:', error);
    
    // Default to allowing generation if we can't check (better user experience)
    return {
      canGenerate: true,
      message: null,
      subscriptionStatus: 'unknown',
      trialGenerationsLeft: 0
    };
  }
};